module.exports = __webpack_public_path__ + "img/winerack06.c346dac0.jpg";